import React from 'react';
import Divider from '@material-ui/core/Divider';
import styled from 'styled-components';
import userMenuLinks from './userMenuLinks';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import useAppContext from '../../../hooks/context/useAppContext';
import { useAuthentication } from '../../../hooks/api/useAuthentication';
import { useIntl } from 'react-intl';

const UserMenuHeader = styled.div`
  width: 300px;
  padding: 20px;
  display: flex;
  flex-direction: row;

  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-weight: 400;
    color: #00c752;
    text-transform: uppercase;
  }
  span:first-child {
    flex-shrink: 0;
    flex-grow: 0;
    width: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  span:last-child {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    justify-content: left;
  }
`;

const UserMenuList = styled.ul`
  list-style: none;
  margin: 5px 0;
  padding: 0;
  a,
  button {
    display: block;
    width: 100%;
    padding: 8px 16px;
    text-align: left;
    text-decoration: none;
    color: inherit;
    background: none;
    border: none;
    font: inherit;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
  }
`;

const UserMenuContent = ({ handleClose = () => {} }) => {
  const { getUser } = useAppContext();
  const { logout } = useAuthentication();
  const intl = useIntl();
  const user = getUser();
  const role = user.role;

  const activeLinks = userMenuLinks[role];

  return (
    <>
      <UserMenuHeader>
        {user?.userAvatar && (
          <span>
            <img src={user.userAvatar} style={{ width: '30px' }} alt="" />
          </span>
        )}
        <span>
          {user.firstname} {user.surname}
        </span>
      </UserMenuHeader>
      <Divider />
      <UserMenuList>
        {activeLinks?.map((link, index) => (
          <li key={index}>
            <NavLink to={link.path} exact={link.exact} onClick={handleClose}>
              {intl.formatMessage({ id: link.label })}
            </NavLink>
          </li>
        ))}
        <li>
          <button onClick={logout}>{intl.formatMessage({ id: 'app.userMenu.logout' })}</button>
        </li>
      </UserMenuList>
    </>
  );
};

UserMenuContent.propTypes = {
  handleClose: PropTypes.func,
};

export default UserMenuContent;
